import { render } from "./pie_chart_4.svg?vue&type=template&id=29dc7e02"
const script = {}
script.render = render

export default script